import type { Mission } from "@components/Map/type";
import type { DeliveryType } from "@types_def/models/delivery.types";

import type { FindDeliveryByIdQuery } from "@/libs/generated/operations";

type DeliveryForMission = FindDeliveryByIdQuery["findDeliveryById"];

export function buildMissionFromDelivery(
  delivery: DeliveryForMission,
  deliveryType: DeliveryType
): Mission[] {
  const from = delivery.fromAddress;
  const to = delivery.toAddress;
  const toReturn = delivery.toReturnToAddress;

  return [
    {
      status: delivery.status ?? "NEW",
      origin: { lng: from?.longitude ?? 0, lat: from?.latitude ?? 0 },
      destination: { lng: to?.longitude ?? 0, lat: to?.latitude ?? 0 },
      depart: from?.address ?? "",
      arrive: to?.address ?? "",
      color: "green",
      id: delivery.id.toString(),
      restitution: toReturn?.address ?? "",
      toReturn: { lng: toReturn?.longitude ?? 0, lat: toReturn?.latitude ?? 0 },
      type: deliveryType,
      destinationCity: to?.city,
      originCity: from?.city,
    },
  ];
}
